import { Product } from "constants/product";

import { IProduct, useOrganization } from "./use-organizations";

export function textAppProductExists(products: IProduct[]): boolean {
  return products.some(({ product }) => (product as Product) === Product.TextApp);
}

export const useHasTextApp = (): boolean | undefined => {
  const { organization } = useOrganization();

  if (organization.products === undefined) {
    return undefined;
  }

  return textAppProductExists(organization.products);
};
